module.exports = __webpack_public_path__ + "img/card-parcel-100.f6852ff.webp";